"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiPriceGet422ResponseToJSON = exports.ApiPriceGet422ResponseFromJSONTyped = exports.ApiPriceGet422ResponseFromJSON = exports.instanceOfApiPriceGet422Response = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the ApiPriceGet422Response interface.
 */
function instanceOfApiPriceGet422Response(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfApiPriceGet422Response = instanceOfApiPriceGet422Response;
function ApiPriceGet422ResponseFromJSON(json) {
    return ApiPriceGet422ResponseFromJSONTyped(json, false);
}
exports.ApiPriceGet422ResponseFromJSON = ApiPriceGet422ResponseFromJSON;
function ApiPriceGet422ResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'errors': !(0, runtime_1.exists)(json, 'errors') ? undefined : json['errors'],
    };
}
exports.ApiPriceGet422ResponseFromJSONTyped = ApiPriceGet422ResponseFromJSONTyped;
function ApiPriceGet422ResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'errors': value.errors,
    };
}
exports.ApiPriceGet422ResponseToJSON = ApiPriceGet422ResponseToJSON;
